module.exports = __webpack_public_path__ + "static/media/icon_11.66f8fd60.png";